/*
* Copyright (c) 2021 RCSB PDB and contributors, licensed under MIT, See LICENSE file for more info.
* @author Joan Segura Mora <joan.segura@rcsb.org>
*/
export class NullBehaviourObserver {
    observe(structureViewer, stateManager) {
    }
    unsubscribe() {
    }
}
